<template>
<div>
    <v-responsive>
        <v-card>
            <v-card-title class="text-center">Welcome</v-card-title>
            <v-card-subtitle>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-autocomplete class="input-field" v-model="send.branch_id" :items="branch" item-text="branch_name" item-value="branch_id" label="Branch" clearable dense filled multiple deletable-chips small-chips solo />
                    </v-col>
                    <v-col cols="12" md="4" class="text-center">
                        <v-autocomplete class="input-field" v-model="send.project_id" :items="project" item-text="project_name" item-value="project_id" label="Project Name" clearable dense filled multiple deletable-chips small-chips solo />
                    </v-col>
                    <v-col cols="12" md="2">
                      <v-dialog ref="dialog" v-model="modal" :return-value.sync="send.date_onsite" persistent width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field v-model="send.date_onsite" label="วันที่" prepend-icon="" readonly v-on="on" outlined dense></v-text-field>
                                </template>
                                <v-date-picker v-model="send.date_onsite" scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                                    <v-btn text color="primary" @click="
                                                $refs.dialog.save(send.date_onsite)
                                            ">OK</v-btn>
                                </v-date-picker>
                            </v-dialog>
                    </v-col>
                    <v-col cols="12" md="" class="button-action">
                        <v-btn color="amber" class="white--text" @click="clear()" :disabled="send.project_id == '' && send.branch_id == '' && send.date_onsite === ''">
                            Clear
                        </v-btn>
                        <v-btn color="success" class="white--text" @click="send_filter()" :disabled="send.project_id == '' && send.branch_id == '' || send.date_onsite === ''">
                            Send
                        </v-btn>
                    </v-col>
                </v-row>
                <v-divider></v-divider>
            </v-card-subtitle>

            <v-card-text v-if="report_data.length != 0">
                <v-row v-for="(branch, bIndex) in report_data" :key="bIndex">
                    <v-col cols="12">
                        <u>
                            <h2 class="branch">{{ branch.branch_name }}</h2>
                        </u>
                        <v-divider></v-divider>
                        <v-simple-table dense class="table-style">
                            <thead class="table-header">
                                <th class="emp-name">Employees</th>
                                <th style="width: 100px;" class="text-center" v-for="(slot, tIndex) in time" :key="tIndex">

                                    {{ slot }}
                                </th>
                            </thead>
                            <tbody>
                                <tr style="border-collapse:1px;" v-for="(employee, eIndex) in branch.engineer" :key="eIndex">
                                    <td style="width: 250px; ">

                                        <v-avatar size="40px">
                                            <v-img :src="url_pic + employee.img_path" :alt="employee.engineer_name" />
                                        </v-avatar>

                                        <p class="emp-id">{{ employee.engineer+": "+employee.engineer_namex}}</p>
                                    </td>
                                    <td v-for="(slot, tIndex) in time" :key="tIndex" :class="{ 'bg-color': employee.schedule.some(s => s.schedule_range === slot)}">
                                        <template v-if="employee.schedule.some(s => s.schedule_range === slot)">
                                            <v-btn small text style="width: 120px;" color="primary" class="id" v-for="schedule in employee.schedule" :key="schedule.case_id" @click="case_detail(schedule)" v-if="schedule.schedule_range === slot"><u class="id"><b>{{ schedule.case_id }}</b></u></v-btn>
                                        </template>
                                        <template v-else>
                                            <template v-if="slot === 'No schedule'">
                                                <v-btn small color="amber" style="width: 120px;" v-for="schedule in employee.schedule" :key="schedule.case_id" @click="case_detail(schedule)" v-if="schedule.schedule_range === null">
                                                    {{ schedule.case_id}}
                                                </v-btn>
                                             <!-- <v-btn small color="amber" style="width: 100px;" v-for="schedule in schedule" :key="schedule.case_id" @click="case_detail(schedule)" v-if="schedule.schedule_range === null">
                                                    {{ schedule.case_id}}
                                                </v-btn> -->

                                                <!-- <v-btn small text style="width: 100px;" color="white" disabled>No schedule</v-btn> -->
                                            </template>
                                            <template v-else>
                                                <v-btn small text style="width: 120px;" color="white" disabled class="text-h">No schedule</v-btn>
                                            </template>
                                        </template>
                                    </td>
                                </tr>

                            </tbody>
                        </v-simple-table>
                    </v-col>

                </v-row>

            </v-card-text>
            <v-card-text v-else align="center">
                <h1 class="text--center"> No data from your query!!!</h1>
                <h3 class="text--center"> Please select new....</h3>
            </v-card-text>

        </v-card>

    </v-responsive>

    <v-dialog v-model="dialog_loading" overlay persistent width="420">
        <v-card color="info" dark>
            <v-card-text>
                <span class="mt-2 white--text">Loading</span>
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="case_details" min-width="600px" max-width="900px">
        <v-card>
            <v-toolbar color="info" dark class="font-b"> <u>{{this.case.project_name}}</u>: {{this.case.case_id}}
                <div class="pop-up">
                    <div v-if="this.case.schedule_range === null" class="text-h4 pa-2"><b>|Time: No schedule</b></div>
                    <div v-else class="mb-1">|Time: <b>{{this.case.schedule_range}}</b></div>
                </div>
                <v-spacer></v-spacer>
                <v-btn text small rounded @click="case_details = false">x</v-btn>
            </v-toolbar>
            <v-card-text>
                <div class="text-h4 pa-2">Case title: <b>{{this.case.case_title}}</b></div>
                <div class="text-h4 pa-2">Maincase id: <b>{{this.case.maincase_id}}</b></div>
                <div v-if="this.case.wonumber === null" class="text-h4 pa-2">WO: <b>-</b></div>
                <div v-else class="text-h4 pa-2">WO: <b>{{this.case.wonumber}}</b></div>

                <div class="text-h4 pa-2">Details: <b>{{this.case.case_title}}</b></div>
                <div class="text-h4 pa-2">Site address: <b>{{this.case.site_address}}</b></div>
                <div class="text-h4 pa-2">Maincase status: <b>{{this.case.main_status_name}}</b></div>
                <div class="text-h4 pa-2">Subcase status: <b>{{this.case.sub_status_name}}</b></div>

            </v-card-text>

        </v-card>
    </v-dialog>

</div>
</template>

<script>
import axios from 'axios'
const url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    beforeMount() {
        this.tk = {
            headers: {
                Authorization: "Bearer " + localStorage.token
            },
        };

        // this.send_filter();
    },
    mounted() {
        this.getBranch();
        this.getProject();
        this.chart_compile();

    },

    data() {
        return {
            modal:false,
            labels: [],
            value: [],

            // -----------------------------------------------------------------------------------------------------
            overlay: false,
            case: {},
            case_details: false,
            dialog_loading: false,
            url_pic: `${process.env.VUE_APP_ROOT_API}/api/profile_img/`,
            branch: [],
            project: [],
            send: {
                branch_id: [],
                project_id: [],
                date_onsite :'',
            },
            report_data: [
               // {
                //       branch_name: "Rayong",
                //       engineer: [
                //         {
                //               "img_path": "P10-172.png",
                //               "engineer": "P10-172",
                //               "engineer_namex": "Surasak Songma",
                //               "onsite_at": "2024-04-18",
                //               "schedule": [{
                //                       "maincase_id": "887395",
                //                       "wonumber": null,
                //                       "case_id": "2404180003",
                //                       "case_title": "เปิดงานให้ช่างเข้าอบรม safety ที่บริษัท เอเอที ในวันที่ 18/4/2024",
                //                       "site_address": "บริษัท เอเอที",
                //                       "main_status_name": "Pending CE",
                //                       "sub_st atus_name": "Assigned",
                //                       "project_name": "BD Request",
                //                       "schedule_range": "10:00 - 11:00"
                //                   },
                //                   {
                //                       "maincase_id": "866481",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "D5121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "CDAX",
                //                       "schedule_range": "13:00 - 14:00"
                //                   },
                //                   {
                //                       "maincase_id": "121212",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "1121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "Test task in the same",
                //                       "schedule_range": "13:00 - 14:00"
                //                   },
                //                   {
                //                       "maincase_id": "866481",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "D5121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "CDAX",
                //                       "schedule_range": "16:00 - 17:00"
                //                   },
                //                   {
                //                       "maincase_id": "866481",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "D5121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "CDAX",
                //                       "schedule_range": null
                //                   },
                //                   {
                //                       "maincase_id": "866481",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "D5121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "CDAX",
                //                       "schedule_range": null
                //                   }, {
                //                       "maincase_id": "866481",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "D5121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "CDAX",
                //                       "schedule_range": null
                //                   }
                //               ]
                //           },
                //           {
                //               "img_path": "P10-172.png",
                //               "engineer": "P24-006",
                //               "engineer_namex": "Anawat Bongprom",
                //               "onsite_at": "2024-04-18",
                //               "schedule": [{
                //                       "maincase_id": "887395",
                //                       "wonumber": null,
                //                       "case_id": "2404180003",
                //                       "case_title": "เปิดงานให้ช่างเข้าอบรม safety ที่บริษัท เอเอที ในวันที่ 18/4/2024",
                //                       "site_address": "บริษัท เอเอที",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "BD Request",
                //                       "schedule_range": "06:00 - 08:00"
                //                   },
                //                   {
                //                       "maincase_id": "866481",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "D5121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "CDAX",
                //                       "schedule_range": "12:00 - 13:00"
                //                   },
                //                   {
                //                       "maincase_id": "866481",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "D5121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "CDAX",
                //                       "schedule_range": "14:00 - 15:00"
                //                   },
                //                   {
                //                       "maincase_id": "866481",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "D5121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "CDAX",
                //                       "schedule_range": "19:00 - 23:59"
                //                   },
                //                   {
                //                       "maincase_id": "866481",
                //                       "wonumber": "WO-024915952",
                //                       "case_id": "D5121579997",
                //                       "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                       "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                       "main_status_name": "Pending CE",
                //                       "sub_status_name": "Assigned",
                //                       "project_name": "CDAX",
                //                       "schedule_range": null
                //                   }
                //               ]
                //           }
                //       ]
                //   },
                //   {
                //       branch_name: "HQ",
                //       engineer: [{
                //           "img_path": "P11-173.png",
                //           "engineer": "P10-172",
                //           "engineer_namex": "Sopong ",
                //           "onsite_at": "2024-04-18",
                //           "schedule": [{
                //                   "maincase_id": "887395",
                //                   "wonumber": null,
                //                   "case_id": "2404180003",
                //                   "case_title": "เปิดงานให้ช่างเข้าอบรม safety ที่บริษัท เอเอที ในวันที่ 18/4/2024",
                //                   "site_address": "บริษัท เอเอที",
                //                   "main_status_name": "Pending CE",
                //                   "sub_status_name": "Assigned",
                //                   "project_name": "BD Request",
                //                   "schedule_range": "08:00 - 09:00"
                //               },
                //               {
                //                   "maincase_id": "866481",
                //                   "wonumber": "WO-024915952",
                //                   "case_id": "5121579997",
                //                   "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                   "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                   "main_status_name": "Pending CE",
                //                   "sub_status_name": "Assigned",
                //                   "project_name": "CDAX",
                //                   "schedule_range": "12:00 - 13:00"
                //               },
                //               {
                //                   "maincase_id": "866481",
                //                   "wonumber": "WO-024915952",
                //                   "case_id": "5121579997",
                //                   "case_title": "TH/05R/NCD/ONS/HP LaserJet Pro MFP 4103fdn Printer/RY/Panel Broken./Engineer check.  (Quote part no.W2Q13-60103  with selling price)",
                //                   "site_address": "130 Moo.3  Nong Lalok\r\nBan Khai \r\nRayong  21120\r\nThailand",
                //                   "main_status_name": "Pending CE",
                //                   "sub_status_name": "Assigned",
                //                   "project_name": "CDAX",
                //                   "schedule_range": null
                //               }
                //           ]
                //       }]
                //   },
            ],
            time: [
                "No schedule",
                "06:00 - 08:00",
                "08:00 - 09:00",
                "09:00 - 10:00",
                "10:00 - 11:00",
                "11:00 - 12:00",
                "12:00 - 13:00",
                "13:00 - 14:00",
                "14:00 - 15:00",
                "15:00 - 16:00",
                "16:00 - 17:00",
                "17:00 - 18:00",
                "18:00 - 19:00",
                "19:00 - 23:59",
            ]
        }
    },
    methods: {
        case_detail(task) {
            this.case = task

            this.case_details = true
        },
        clear() {
            this.send.branch_id = '';
            this.send.project_id = '';
            this.send.date_onsite = '';
            this.report_data = '';
            this.chart_compile()
        },
        async getProject() {
            await axios.get(url + "it/get-project", this.tk)
                .then((response) => {

                    this.project = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async getBranch() {
            await axios.get(url + "it/get-branch", this.tk)
                .then((response) => {

                    this.branch = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        async send_filter() {
        //   console.log(this.send)
            this.dialog_loading = true
            await axios.post(url + "it/check-case/view-all", this.send, this.tk)
                .then((response) => {

                    this.report_data = response.data;

                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error);
                })

            this.report_data.map((f) => {
                f.engineer.map((s) => {
                        s.schedule.map((sh) => {
                            if (sh.case_id === "5123578915") {
                                // console.log("finding", sh.case_id, sh.sub_status_name)
                            }
                        })
                    }
                    //f[i].engineer[i].schedule[i]
                )

            })

        },

        chart_compile() {
            let l = []
            let v = []
            for (let i = 0; i < this.report_data.length; i++) {

                this.labels[i] = this.report_data[i].branch_name
                this.value[i] = this.report_data[i].engineer.length

            }

        },

    },
    watch: {
        overlay(val) {
            val && setTimeout(() => {
                this.overlay = false
            }, 3000)
        },
    }
}

// Remove the extra closing curly brace '}' at the end of the code block
// }
</script>

<style scoped>
.id {
    text: font-weight-black;
    font-size: 13px;
    color: black;
}

table tr+th .emp-name {
    border-left: 1px solid #000000;
    border-style: solid;
    width: 300px;
    border-bottom: 1px solid black;
}

table td+td {
    border-left: 1px solid #000000;
}

.fixed-width {
    width: 200px;
}

.input-field {
    margin-bottom: 10px;
}

table {
    border-collapse: 1px solid;
}

.bg-color {
    background-color: #B3E5FC;

}

.button-action {
    text-align: center;
    padding-top: -30px;
}

.schedule-range {
    padding: 5px 10px;
    border-radius: 4px;
    font-weight: bold;
    font-size: 12px;
    font-family: "Courier New", Courier, monospace;
}

.not-scheduled {
    background-color: #ffcc80;
}

.hidden {
    display: none;
}

.table-style {
    border: 1px solid black;
    border-spacing: 1px;
    border-top: 2px solid black;
    border-bottom: 2px solid black;

}

.table-header {
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    background-color: #0289d1d3;
    border-radius: 20px;
    color: #FFFFFF;

}

.header {
    background-color: #7f97a1;
}

.branch {
    color: black;
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif
}

.header-width {
    max-width: 200px;
}

.emp-id {
    font-size: 13px;
    justify-content: Start;
    font-weight: bold;
}

.emp-id {
    font-size: 13px;

    font-weight: bold;
}

.pop-up {
    align-content: start;
    justify-content: center;
}

.v-sheet--offset {
    top: -24px;
    position: relative;
}

.text-h {
    opacity: 0%;
}
</style>
